import { render, staticRenderFns } from "./RequestTable.vue?vue&type=template&id=2fabf214&scoped=true&lang=pug&"
import script from "./RequestTable.vue?vue&type=script&lang=js&"
export * from "./RequestTable.vue?vue&type=script&lang=js&"
import style0 from "./RequestTable.vue?vue&type=style&index=0&id=2fabf214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabf214",
  null
  
)

export default component.exports